'use client';

import { cx } from 'class-variance-authority';
import type { ClassValue } from 'class-variance-authority/types';
import { usePlpExperiment } from './plpExperiment';

/**
 * The band the filters and results sit in.
 *
 * Region and city pages paint that band dark, each in their own way — one from
 * a Storyblok field, one hardcoded. The reworked page is beige everywhere, so
 * rather than teaching every entry point its own exception they hand both
 * options here and this picks. The control group keeps the page's own colour.
 */
export const PlpFunctionalBackground: React.FC<{
    /** Applied to the control group: whatever the page paints today. */
    control: ClassValue;
    /** Applied to the reworked page. */
    finetuning: ClassValue;
    className?: ClassValue;
    id?: string;
    children: React.ReactNode;
}> = props => {
    const isFinetuning = usePlpExperiment();

    return (
        <div
            id={props.id}
            className={cx(props.className, isFinetuning ? props.finetuning : props.control)}
        >
            {props.children}
        </div>
    );
};
